import { RSAA } from 'redux-api-middleware';
import {
  CHANGE_DATE,
  GET_SHIFTS_START,
  GET_SHIFTS_SUCCESS,
  GET_SHIFTS_FAIL,
  GET_ALLEMPLOYEES_START,
  GET_ALLEMPLOYEES_SUCCESS,
  GET_ALLEMPLOYEES_FAIL,
  CREATE_SHIFT_START,
  CREATE_SHIFT_SUCCESS,
  CREATE_SHIFT_FAIL,
  UPDATE_SHIFT_START,
  UPDATE_SHIFT_SUCCESS,
  UPDATE_SHIFT_FAIL,
  DELETE_SHIFTS_START,
  DELETE_SHIFTS_SUCCESS,
  DELETE_SHIFTS_FAIL,
  ADD_SHIFT,
  CALCULATE_SHIFT_TIPS,
  SPLIT_LUNCH_SERVER_TIPS,
  VALIDATE_LUNCH_TIPS,
  VALIDATE_DINNER_TIPS,
  DELETE_SHIFT_START,
  DELETE_SHIFT_SUCCESS,
  DELETE_SHIFT_FAIL,
  GET_RESTAURANT_START,
  GET_RESTAURANT_SUCCESS,
  GET_RESTAURANT_FAIL,
  UPDATE_REPORT_RESTAURANT_ID,
  UPDATE_REPORT_BEGIN_DATE,
  UPDATE_REPORT_END_DATE,
  GET_REPORT_SUSHI_TIPOUT_START,
  GET_REPORT_SUSHI_TIPOUT_SUCCESS,
  GET_REPORT_SUSHI_TIPOUT_FAIL,
  GET_REPORT_EMPLOYEE_TIPOUT_START,
  GET_REPORT_EMPLOYEE_TIPOUT_SUCCESS,
  GET_REPORT_EMPLOYEE_TIPOUT_FAIL,
  UPDATE_REPORT_EMPLOYEE_ID,
  GET_REPORT_EMPLOYEE_SHIFTS_START,
  GET_REPORT_EMPLOYEE_SHIFTS_SUCCESS,
  GET_REPORT_EMPLOYEE_SHIFTS_FAIL,
  SPLIT_DINNER_SERVER_TIPS,
  ADD_EMPLOYEE_START,
  ADD_EMPLOYEE_SUCCESS,
  ADD_EMPLOYEE_FAIL,
  DELETE_EMPLOYEE_START,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_FAIL,
  LOGIN_SUCCESSFUL,
  GET_USER_START,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  UPDATE_MYSHIFTS_BEGIN_DATE,
  UPDATE_MYSHIFTS_END_DATE,
  GET_MYSHIFTS_START,
  GET_MYSHIFTS_SUCCESS,
  GET_MYSHIFTS_FAIL,
  UPDATE_EMPLOYEE_START,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_FAIL,
  COPY_SHIFT,
} from './actionTypes';

import { API_URL, REDIRECT_URL } from '../config';

// API call actions
export const getAuthHeader = () => {
  const access_token = localStorage.getItem('access_token');
  return 'Bearer ' + access_token;
};
export const getRestaurantSettings = (restaurantId) => ({
  [RSAA]: {
    endpoint: API_URL + '/restaurant/' + restaurantId,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    types: [GET_RESTAURANT_START, GET_RESTAURANT_SUCCESS, GET_RESTAURANT_FAIL],
  },
});

export const getShifts = (restaurantId, date) => ({
  [RSAA]: {
    endpoint:
      API_URL +
      '/shifts?date=' +
      getFormattedDate(date) +
      '&restaurantId=' +
      restaurantId,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    types: [GET_SHIFTS_START, GET_SHIFTS_SUCCESS, GET_SHIFTS_FAIL],
  },
});

export const createShift = (restaurantId, date, index, shift) => ({
  [RSAA]: {
    endpoint: API_URL + '/shift',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    body: JSON.stringify({
      ...shift,
      RestaurantID: parseInt(restaurantId),
      Index: index,
      Date: date,
    }),
    types: [CREATE_SHIFT_START, CREATE_SHIFT_SUCCESS, CREATE_SHIFT_FAIL],
  },
});

export const updateShift = (id, shift) => ({
  [RSAA]: {
    endpoint: API_URL + '/shift/' + id,
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    body: JSON.stringify(shift),
    types: [UPDATE_SHIFT_START, UPDATE_SHIFT_SUCCESS, UPDATE_SHIFT_FAIL],
  },
});

export const deleteShift = (id) => ({
  [RSAA]: {
    endpoint: API_URL + '/shift/' + id,
    method: 'DELETE',
    headers: { Authorization: getAuthHeader() },
    types: [DELETE_SHIFT_START, DELETE_SHIFT_SUCCESS, DELETE_SHIFT_FAIL],
  },
});

export const deleteShiftsByDate = (restaurantId, date) => ({
  [RSAA]: {
    endpoint:
      API_URL +
      '/shifts?date=' +
      getFormattedDate(date) +
      '&restaurantId=' +
      restaurantId,
    method: 'DELETE',
    types: [DELETE_SHIFTS_START, DELETE_SHIFTS_SUCCESS, DELETE_SHIFTS_FAIL],
  },
});

export const getAllEmployees = (restaurantId) => ({
  [RSAA]: {
    endpoint: API_URL + '/allemployees?restaurantId=' + restaurantId,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    types: [
      GET_ALLEMPLOYEES_START,
      GET_ALLEMPLOYEES_SUCCESS,
      GET_ALLEMPLOYEES_FAIL,
    ],
  },
});

export const getReportSushiTipout = (restaurantId, beginDate, endDate) => ({
  [RSAA]: {
    endpoint:
      API_URL +
      '/sushitipout?restaurantId=' +
      restaurantId +
      '&from=' +
      getFormattedDateForReport(beginDate) +
      '&to=' +
      getFormattedDateForReport(endDate),
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    types: [
      GET_REPORT_SUSHI_TIPOUT_START,
      GET_REPORT_SUSHI_TIPOUT_SUCCESS,
      GET_REPORT_SUSHI_TIPOUT_FAIL,
    ],
  },
});

export const getReportEmployeeShifts = (
  restaurantId,
  employeeId,
  beginDate,
  endDate,
) => ({
  [RSAA]: {
    endpoint:
      API_URL +
      '/employeeshifts?restaurantId=' +
      restaurantId +
      '&employeeID=' +
      employeeId +
      '&from=' +
      getFormattedDateForReport(beginDate) +
      '&to=' +
      getFormattedDateForReport(endDate),
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    types: [
      GET_REPORT_EMPLOYEE_SHIFTS_START,
      GET_REPORT_EMPLOYEE_SHIFTS_SUCCESS,
      GET_REPORT_EMPLOYEE_SHIFTS_FAIL,
    ],
  },
});

export const getReportEmployeeTipOut = (
  restaurantId,
  employeeId,
  employeeName,
  beginDate,
  endDate,
) => ({
  [RSAA]: {
    endpoint:
      API_URL +
      '/tipout?restaurantId=' +
      restaurantId +
      '&employeeID=' +
      employeeId +
      '&from=' +
      getFormattedDateForReport(beginDate) +
      '&to=' +
      getFormattedDateForReport(endDate),
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    fetch: async (...args) => {
      const res = await fetch(...args);
      const json = await res.json();

      return new Response(
        JSON.stringify({
          ...json,
          // Adding or updating to the JSON response
          TipOutSummary: Number(json.TipOutSummary.toFixed(2)),
          employeeId,
          employeeName,
        }),
        {
          // Custom success/error status based on an `error` key in the API response
          status: json.error ? 500 : 200,
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
    },
    types: [
      GET_REPORT_EMPLOYEE_TIPOUT_START,
      GET_REPORT_EMPLOYEE_TIPOUT_SUCCESS,
      GET_REPORT_EMPLOYEE_TIPOUT_FAIL,
    ],
  },
});

export const addEmployee = (restaurantId, employeeName) => ({
  [RSAA]: {
    endpoint: API_URL + '/employee',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    body: JSON.stringify({
      RestaurantID: parseInt(restaurantId),
      Name: employeeName,
    }),
    types: [ADD_EMPLOYEE_START, ADD_EMPLOYEE_SUCCESS, ADD_EMPLOYEE_FAIL],
  },
});

export const updateEmployee = (employee) => ({
  [RSAA]: {
    endpoint: API_URL + '/employee/' + employee.ID,
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    body: JSON.stringify(employee),
    types: [
      UPDATE_EMPLOYEE_START,
      UPDATE_EMPLOYEE_SUCCESS,
      UPDATE_EMPLOYEE_FAIL,
    ],
  },
});

export const deleteEmployee = (employeeId) => ({
  [RSAA]: {
    endpoint: API_URL + '/employee/' + employeeId,
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    fetch: async (...args) => {
      const res = await fetch(...args);
      const json = await res.json();

      return new Response(
        JSON.stringify({
          ...json,
          employeeId,
        }),
        {
          // Custom success/error status based on an `error` key in the API response
          status: json.error ? 500 : 200,
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
    },
    types: [
      DELETE_EMPLOYEE_START,
      DELETE_EMPLOYEE_SUCCESS,
      DELETE_EMPLOYEE_FAIL,
    ],
  },
});

export const getUser = () => ({
  [RSAA]: {
    endpoint: API_URL + '/user',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    types: [GET_USER_START, GET_USER_SUCCESS, GET_USER_FAIL],
  },
});

export const getMyShifts = (beginDate, endDate) => ({
  [RSAA]: {
    endpoint:
      API_URL +
      '/myshifts?from=' +
      getFormattedDateForReport(beginDate) +
      '&to=' +
      getFormattedDateForReport(endDate),
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthHeader(),
    },
    types: [GET_MYSHIFTS_START, GET_MYSHIFTS_SUCCESS, GET_MYSHIFTS_FAIL],
  },
});

// API call actions end

export const saveUnsavedDailyShifts =
  (restaurantId, date) => (dispatch, getState) => {
    const allShifts = getState().dailyShifts.shifts;
    for (let v = 0; v < allShifts.length; v++) {
      if (!allShifts[v].IsSaved) {
        if (!allShifts[v].ID) {
          dispatch(createShift(restaurantId, date, v, allShifts[v]));
        } else {
          dispatch(updateShift(allShifts[v].ID, allShifts[v]));
        }
      }
    }
  };

export const loginSuccessful = () => {
  return {
    type: LOGIN_SUCCESSFUL,
  };
};

export const handleSelectDate = (restaurantId, date) => {
  return (dispatch, getState) => {
    const unsavedShifts = getState().dailyShifts.shifts.filter(
      (item) => item.IsSaved === false,
    );
    let proceed = false;
    if (unsavedShifts.length > 0) {
      proceed = window.confirm(
        'You have unsaved shift records, do you want to change date?',
      );
    } else {
      proceed = true;
    }
    if (proceed) {
      dispatch({
        type: CHANGE_DATE,
        payload: date,
      });
      dispatch(getRestaurantSettings(restaurantId));
      dispatch(getShifts(restaurantId, date));
    }
  };
};

export const addShift = () => ({
  type: ADD_SHIFT,
  payload: {
    EmployeeID: 1,
    IsLunch: false,
    Title: '',
    NetSales: 0,
    Beer: 0,
    ByBottle: 0,
    Food: 0,
    Liquor: 0,
    MixedCocktails: 0,
    NABeverage: 0,
    Sake: 0,
    Sushi: 0,
    Wine: 0,
    SushiTip: 0,
    BarTip: 0,
    ServerRatio: 1,
    BarRatio: 1,
    ExpoTip: 0,
    ExpoRatio: 1,
    HostRatio: 1,
    BusserRatio: 1,
    HostTip: 0,
    BusserTip: 0,
    CCTipFee: 0,
    CCTip: 0,
    FinalTipOut: 0,
    Notes: '',
    IsSavingShift: false,
    IsSaved: false,
  },
});

export const copyShift = (shiftNumber) => ({
  type: COPY_SHIFT,
  payload: { shiftNumber: shiftNumber },
});

export const saveShift = (restaurantId, date, sid, shiftID) => {
  if (shiftID === undefined) {
    return (dispatch, getState) => {
      const shift = getState().dailyShifts.shifts[sid];
      if (shift.EmployeeID !== 1 && shift.Title === '') {
        alert('please select title!');
        return;
      }
      const datedb = getFormattedDate(date);
      dispatch(createShift(restaurantId, datedb, sid, shift));
    };
  } else {
    return (dispatch, getState) => {
      const shift = getState().dailyShifts.shifts[sid];
      if (shift.EmployeeID !== 1 && shift.Title === '') {
        alert('please select title!');
        return;
      }
      //const datedb = getFormattedDate(date)
      shift.Index = sid;
      dispatch(updateShift(shift.ID, shift));
    };
  }
};

export const deleteShiftAction = (sid, shiftID) => (dispatch, getState) => {
  const shift = getState().dailyShifts.shifts[sid];
  if (
    shiftID !== undefined &&
    (shift.Title === 'Server' || shift.EmployeeID === 1)
  ) {
    if (shift.IsLunch) {
      const nonTipShareShifts = getState().dailyShifts.shifts.filter(
        (i) => i.Title !== 'Server' && i.EmployeeID !== 1 && i.IsLunch === true,
      );
      nonTipShareShifts.forEach((i) => {
        dispatch(deleteShift(i.ID));
      });
      dispatch(deleteShift(shiftID));
    } else {
      const nonTipShareShifts = getState().dailyShifts.shifts.filter(
        (i) =>
          i.Title !== 'Server' && i.EmployeeID !== 1 && i.IsLunch === false,
      );
      nonTipShareShifts.forEach((i) => {
        dispatch(deleteShift(i.ID));
      });
      dispatch(deleteShift(shiftID));
    }
  }
};

export const splitLunchServerTips = () => ({
  type: SPLIT_LUNCH_SERVER_TIPS,
});

export const splitDinnerServerTips = () => ({
  type: SPLIT_DINNER_SERVER_TIPS,
});

export const calculateShiftTips = (sid) => ({
  type: CALCULATE_SHIFT_TIPS,
  payload: {
    sid: sid,
  },
});

export const validateLunchTips = () => ({
  type: VALIDATE_LUNCH_TIPS,
});

export const validateDinnerTips = () => ({
  type: VALIDATE_DINNER_TIPS,
});

export const updateField = (sid, value, fieldName) => ({
  type: 'UPDATE_' + fieldName,
  payload: {
    sid: sid,
    value: value,
  },
});

export const getFormattedDate = (date) => {
  var year = date.getFullYear();

  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;

  var day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;

  return month + '/' + day + '/' + year;
};

export const getFormattedDateForReport = (date) => {
  var year = date.getFullYear();

  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;

  var day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;

  return year + '-' + month + '-' + day;
};

export const updateReportRestaurantId = (restaurantId) => ({
  type: UPDATE_REPORT_RESTAURANT_ID,
  payload: restaurantId,
});

export const getReport =
  (restaurantId, employeeId, beginDate, endDate) =>
  async (dispatch, getState) => {
    await dispatch(getReportSushiTipout(restaurantId, beginDate, endDate));
    if (employeeId !== 1 && employeeId !== undefined) {
      const employeeName = getEmployeeNameById(getState, employeeId);
      await dispatch(
        getReportEmployeeTipOut(
          restaurantId,
          employeeId,
          employeeName,
          beginDate,
          endDate,
        ),
      );
      //await dispatch(getReportEmployeeShifts(restaurantId, employeeId, beginDate, endDate))
    }
  };

const getEmployeeNameById = (getState, employeeId) => {
  const employees = getState().employees;
  const filtered = employees.filter((i) => i.ID.toString() === employeeId);
  if (filtered.length > 0) {
    return filtered[0].Name;
  } else {
    return '';
  }
};

export const handleSelectReportBeginDate = (date) => ({
  type: UPDATE_REPORT_BEGIN_DATE,
  payload: date,
});

export const handleSelectReportEndDate = (date) => ({
  type: UPDATE_REPORT_END_DATE,
  payload: date,
});

export const handleSelectMyShiftsBeginDate = (date) => ({
  type: UPDATE_MYSHIFTS_BEGIN_DATE,
  payload: date,
});

export const handleSelectMyShiftsEndDate = (date) => ({
  type: UPDATE_MYSHIFTS_END_DATE,
  payload: date,
});

export const updateReportEmployeeId = (employeeId) => ({
  type: UPDATE_REPORT_EMPLOYEE_ID,
  payload: employeeId,
});

export const logout = () => {
  localStorage.removeItem('access_token');
  window.location =
    'https://soto.auth.us-east-1.amazoncognito.com/logout?client_id=1ntv7eg3d82d79mldq0tbtpod2&response_type=token&redirect_uri=' +
    encodeURIComponent(REDIRECT_URL);
};
